import InputNumber from './InputNumber';

export default InputNumber;



// WEBPACK FOOTER //
// ./src/components/input-number/index.js